// extracted by mini-css-extract-plugin
export default {"notification":"style_notification__2hv3L","fade-out":"style_fade-out__Kvd7z"};